import { useEffect } from 'react'

let scrollLockCount = 0
let lockedScrollY = 0
let prevBodyPosition = ''
let prevBodyTop = ''
let prevBodyLeft = ''
let prevBodyRight = ''
let prevBodyWidth = ''

const applyScrollLock = () => {
  if (scrollLockCount === 0) {
    lockedScrollY = window.scrollY || window.pageYOffset || 0
    const body = document.body
    prevBodyPosition = body.style.position
    prevBodyTop = body.style.top
    prevBodyLeft = body.style.left
    prevBodyRight = body.style.right
    prevBodyWidth = body.style.width

    body.style.position = 'fixed'
    body.style.top = `-${lockedScrollY}px`
    body.style.left = '0'
    body.style.right = '0'
    body.style.width = '100%'

    body.classList.add('noScroll')
    document.documentElement.classList.add('noScroll')
  }
  scrollLockCount += 1
}

const releaseScrollLock = () => {
  scrollLockCount = Math.max(0, scrollLockCount - 1)
  if (scrollLockCount > 0) return

  const body = document.body
  body.classList.remove('noScroll')
  document.documentElement.classList.remove('noScroll')

  body.style.position = prevBodyPosition
  body.style.top = prevBodyTop
  body.style.left = prevBodyLeft
  body.style.right = prevBodyRight
  body.style.width = prevBodyWidth

  window.scrollTo(0, lockedScrollY)
}

export const useClearBodyNoScrollClass = () => {
  useEffect(() => {
    applyScrollLock()
    return () => {
      releaseScrollLock()
    }
  }, [])
}
